<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Trainee/traineeDashboard'
                    },
                   {
                      title: 'Evenet Gallery',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="heading mt-3">
              <h3 class="text-secondary">Image Gallery</h3>
            </div>
            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Event Information</h6>
              <div class="row col-sm-12">
                <label class="col-sm-1 font-weight-bold">Title:</label>
                <div class="col-sm-11">{{title}}</div>
              </div>
            </div>

            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-sm-3 tiles"
                  v-for="(image, i) in images"
                  :key="i"
                  @click="index = i"
                  style="padding-right:0px !important;padding-left:0px !important;"
                >
                  <div class="tile">
                    <img class="gallery-image" :src="image.image" @click="index = i" />
                    <div class="details">
                      <span class="title">{{image.title}}</span>
                    </div>
                  </div>
                </div>
                <vue-gallery-slideshow :images="imagess" :index="index" @close="index = null"></vue-gallery-slideshow>
              </div>
            </div>
            <vs-row vs-justify="center" class="mt-3"></vs-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallerySlideshow from "vue-gallery-slideshow";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

export default {
  data: () => ({
    title: "",
    isSidebar: false,
    images: [],
    BASEPATHDYNAMIC: "",
    index: null,
    trainingCode: "",
    trainingId: "",
    imagess: [],
  }),
  components: {
    VueGallerySlideshow,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
    this.openLoading();
    
    this.trainingCode = this.$route.query.training;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/trainee/training/single/" +
          this.trainingCode +"/get"
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingId = response.data.id;
        this.title = response.data.title;
        this.loadGallery(this.trainingId);
      });
  },
  methods: {
    loadGallery: function loadGallery(id){
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainee/gallery/get/" +
            id
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if(response.data.gallery != null){
            response.data.gallery.forEach(element => {
              this.images.push({title: element.title, image: this.BASEPATHDYNAMIC +"/"+element.uploadfile});
              this.imagess.push(this.BASEPATHDYNAMIC +"/"+element.uploadfile)
            });
          }
        });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },

    onClick(i) {
      // console.log(i);
      this.index = i;
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.gallery-image {
  width: 100%;
  height: 200px;
  background-size: contain;
  cursor: pointer;
  /* margin: 10px; */
  border-radius: 3px;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}

.vgs__container {
  height: 75vh !important;
}

/* thumbnail hover css starts */

.tiles {
  width: 420px;
  font-size: 0;
  /* text-align: center;
  position: absolute; */
  /* top: 50%;
  left: 50%; */
  /* -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%); */
}
.tiles .tile {
  display: inline-block;
  margin: 10px;
  text-align: left;
  opacity: 0.99;
  overflow: hidden;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
}
.tiles .tile:before {
  content: "";
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.7) 100%
  );
  /* background: #000000c4; */
  width: 100%;
  height: 50%;
  opacity: 0;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 2;
  transition-property: top, opacity;
  transition-duration: 0.3s;
}
/* .tiles .tile .thumbnail-img {
  display: block;
  min-width: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
} */
.tiles .tile .details {
  font-size: 16px;
  padding: 20px;
  color: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
}
.tiles .tile .details span {
  display: block;
  opacity: 0;
  position: relative;
  top: 100px;
  transition-property: top, opacity;
  transition-duration: 0.3s;
  transition-delay: 0s;
}
.tiles .tile .details .title {
  line-height: 1;
  font-weight: 600;
  font-size: 18px;
}
.tiles .tile .details .info {
  line-height: 1.2;
  margin-top: 5px;
  font-size: 12px;
}
.tiles .tile:focus:before,
.tiles .tile:focus span,
.tiles .tile:hover:before,
.tiles .tile:hover span {
  opacity: 2;
}
.tiles .tile:focus:before,
.tiles .tile:hover:before {
  top: 50%;
}
.tiles .tile:focus span,
.tiles .tile:hover span {
  top: 0;
}
.tiles .tile:focus .title,
.tiles .tile:hover .title {
  transition-delay: 0.15s;
}
.tiles .tile:focus .info,
.tiles .tile:hover .info {
  transition-delay: 0.25s;
}

/* thumnails hover css ends */
</style>
